// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__nEFXg","items":"style_items__2ePLO","detail":"style_detail__1bJs8","row":"style_row__1DuRp"};